import { render, staticRenderFns } from "./TheFooterBS46.vue?vue&type=template&id=687a4be4&scoped=true"
import script from "./TheFooterBS46.vue?vue&type=script&lang=js"
export * from "./TheFooterBS46.vue?vue&type=script&lang=js"
import style0 from "./TheFooterBS46.vue?vue&type=style&index=0&id=687a4be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a4be4",
  null
  
)

export default component.exports